import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { RenaultManagerDistributorDTO } from '../models/renault-manager-distributor';


@Injectable({
  providedIn: 'root'
})

export class RenaultManagerDistributorService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultManagerDistributor/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultManagerDistributorDTO> {
    return this.http.get<RenaultManagerDistributorDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: RenaultManagerDistributorDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: RenaultManagerDistributorDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  } 

  public downloadDistributorExcel(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetDistributorsExcel';
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public loadDistributorsExcel(file: File): Observable<string[]> {
    let formData: FormData = new FormData();
    if (file != undefined) {
      formData.append('fileDistributor', file, file.name);
    }
    return this.http.post<string[]>(this.pathAPI + this.controller + 'LoadDistributorsExcel', formData);
  }

}
